<template>
  <div class="edu_pages_content_body_box">
    <div class="edu_table_box">
      <el-table
        :data="tableData"
        height="100%"
        class="table_box"
        :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="70" align="center">
          <template slot-scope="scope">
            {{ searchParams.pageSize * (searchParams.pageNum - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="headline"
          label="消息标题"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div :style="scope.row.status == 1 ? 'color:#696969' : 'color:#4169E1'">
              {{ scope.row.headline }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="内容" align="center" width="180">
          <!-- <template slot-scope="scope">
        {{ $Common.getDataName(typeData, scope.row.type) }}
      </template> -->
        </el-table-column>
        <el-table-column prop="senderName" label="发信机构" align="center" width="180">
        </el-table-column>
        <el-table-column prop="releaseTime" label="下发时间" align="center" width="180">
          <template slot-scope="scope">
            {{ $Common.dateFormatDateTwo(scope.row.timestamp) }}
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.state == 1 ? "已查看" : "未查看" }}
          </template>
        </el-table-column>
        <el-table-column prop="releaseTime" label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-link
              class="link_box"
              type="primary"
              @click="itemClick(scope.row)"
              :underline="false"
              >查看详情</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="edu_pagination_box" v-if="resData.total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="searchParams.pageNum"
        :page-size="searchParams.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="resData.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="detailInfo.headline"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <div class="content-box">
        <div class="notice_content_box">{{ detailInfo.message }}</div>
        <div class="user">发信机构：{{ detailInfo.senderName }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "HelpPage",
  data() {
    return {
      searchParams: {
        recipientId: this.$store.getters.getUserInfo.eduId,
        identification: 1,
        pageNum: 1,
        pageSize: 20,
      },
      tableLoading: false,
      tableData: [],
      resData: {},
      detailInfo: {},
      dialogVisible: false,
    };
  },
  computed: {
    typeData() {
      return [
        { id: 1, name: "升级消息" },
        { id: 4, name: "系统消息" },
        { id: 5, name: "通知消息" },
      ];
    },
    statusData() {
      return [
        { id: 1, name: "已读" },
        { id: 2, name: "未读" },
      ];
    },
  },
  created() {},
  mounted() {
    // this.getUnreadMessages();
    this.getList();
  },
  methods: {
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.getList();
    },
    async getList() {
      // console.log("object", this.searchParams);
      this.tableLoading = true;
      let res = await this.$Http.getSchoolNoticesList(this.searchParams);
      this.tableLoading = false;
      if (res.code == 200) {
        this.resData = res.data;
        this.tableData = res.data.list || [];
      } else if (res.code == 101) {
        this.tableData = [];
        this.resData = {
          pageSize: 20,
          pageNum: 0,
          total: 0,
          pages: 0,
          list: [],
        };
      } else {
        this.tableData = [];
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
    itemClick(row) {
      // row.status = 1;
      // this.detailInfo = Object.assign({}, row);
      this.detailInfo = row;
      this.dialogVisible = true;
      // this.modify(row.id);
      this.$Common.updateNoticesStatus(row.notificationNodeId, 2);
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../../public/css/edu_pages.scss";
.content-box {
  width: 100%;
  height: 300px;
  padding: 20px;
}
.notice_content_box {
  font-size: 15px;
  text-indent: 30px;
  height: 100%;
  overflow-y: scroll;
}
.user {
  font-size: 14px;
  text-align: right;
}
</style>
